module.exports = __webpack_public_path__ + "static/equipment2-240cd6f9855d1f33a1517ae74eb453b2.jpg";